export function pad(num, size) {
  if (num === undefined) return null;
  var s = num + '';

  while (s.length < size) s = '0' + s;
  return s;
}

export function findProposal(proposals, proposalId) {
  if (proposals && proposals.length !== 0)
    return proposals.find((proposal) => proposal.id === proposalId);

  return null;
}

export function findProviderInProposals(proposals, providerId) {
  var data_provider = null;

  if (proposals && proposals.length !== 0)
    proposals.forEach((proposal) => {
      if (proposal.data_provider.id === parseInt(providerId))
        data_provider = { ...proposal.data_provider };
    });

  return data_provider;
}

export default { pad, findProposal, findProviderInProposals };
